import { Component, Input } from '@angular/core';
import { TextField, JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { GenericRichTextDirective } from '@core/jss-utils';

@Component({
  selector: 'wl-content-card',
  templateUrl: './content-card.component.html',
  styleUrls: [],
  standalone: true,
  imports: [AutomationIdDirective, JssModule, GenericRichTextDirective],
})
export class ContentCardComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() title?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() body?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() automationId?: string;
}
